import ProductDateOfStorage from '~/themes/base/components/product/ProductDateOfStorage'

export default {
  extends: ProductDateOfStorage,
  computed: {
    hasDateOfStorage() {
      const delayDays = Number(this.product.availability.delayDays)
      return Number.isFinite(delayDays) && delayDays > 0
    },
    dateOfStorage() {
      if (!this.hasDateOfStorage) {
        return []
      }

      return [
        {
          date_of_storage: this.$moment.utc().add(this.product.availability.delayDays, 'day'),
          amount: 1,
          embeddedUuid: 'embeddedUuid',
        },
      ]
    },
    // nearest() {
    //   return this.dateOfStorage[0]
    // },
  },
}
